import React from "react";
import { useSelector } from "react-redux";
import { Routes, Route, Link } from "react-router-dom";
import Announcement from "../announcement/AnnouncementBar";
import Footer from "../footer/Footer";
import Header from "../header/Header";
import routes from "./dashboard-routes";
import "./DashboardLayout.css";

function DashboardLayout(props) {
  const user = useSelector((state) => state.user);
  const roles = () => user?.roles?.map((v) => v.name);
  return (
    <div className="DashboardLayout">
      <Announcement />
      <Header current={props.location.pathname} />
      <div className="container " style={{ width: "100vw", height: "100%", margin:"20px auto" }}>
        <div className="row no-gutters">
          <div className="sidebar">
            <ul style={{ listStyleType: "none", padding: 0 }}>
              {routes
                .filter((route) => {
                  return roles()?.includes(route?.access) ||
                    route.access === "both"
                    ? true
                    : false;
                })
                .filter((route,i,arr)=>{
                  let routpaths = arr.filter(o=>o.path==route.path);
                  return routpaths[0]==route;
                })
                .map((route, i) => (
                  <li key={i}>
                    {/* {console.log("route", route)} */}
                    <Link to={route.path}>
                      {route.icon && typeof route.icon == "function" && (
                        <route.icon />
                      )}
                      {route.icon && typeof route.icon == "string" && (
                        <i className={route.icon}></i>
                      )}
                      {
                        <label>
                          <route.sidebar></route.sidebar>
                        </label>
                      }
                    </Link>
                  </li>
                ))}
            </ul>
          </div>
          <div className="content col customradius">
            <Routes>
              {routes.map((route, index) => {
                // This whole component is already reached via the parent
                // router's "/dashboard/*" route, so this nested <Routes>
                // only ever sees what's left of the URL AFTER "/dashboard"
                // is stripped off. route.path here still holds the full
                // absolute path (e.g. "/dashboard/profile") because
                // dashboard-routes.js also uses it for the sidebar <Link>
                // targets, which do need the absolute form — so re-derive
                // the relative segment ("profile") just for matching here.
                // Left as an absolute "/dashboard/..." pattern, none of
                // these ever matched anything (remaining path is just
                // "/profile", not "/dashboard/profile"), so every route
                // silently rendered blank with no console error.
                const relativePath =
                  route.path.replace(/^\/dashboard\/?/, "") || "/";
                return (
                  <Route
                    key={index}
                    path={relativePath}
                    element={<route.main />}
                  />
                );
              })}
            </Routes>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
export default connect(DashboardLayout);
